/* eslint-disable react/prop-types */
import CarouselHours from '../../../components/CarouselHours';
import SchedulerCalendar from '../../../components/SchedulerCalendar';
import { MultiplySelectSquare } from '../../../components/Select/MultiplySelectSquare';
import styles from './styles.module.css';

import {
  notifyErrorCustom,
} from '../../../utils/notify';

import {
  Calendar2,
  Cross,
  Facebook,
  FacebookChatIcon,
  HashtagIcon,
  Instagram,
  Linkedin,
  LinksIcon,
  LockClosed,
  MorePersonsIcon,
  Picture,
  PinMapsIcon,
  Subtract,
  //Pinterest,
  TikTok,
  TikTokIcon,
  User,
  XTwitter,
} from '../../../assets/svgs/icons';

import { useEffect, useState } from 'react';

import { ImageRender } from '../../../components/ImageRender';
import { ModalComponent } from '../../../components/ModalComponent';
import { SelectSquare } from '../../../components/Select/SelectSquare/SelectSquare';
import {
  LinkedinService,
  MetaService,
  // !-----
  SocialMediaConnectionService,
  TiktokService,
  TwitterService
} from '../../../services';

import {
  getBusinessByClientId,
  getBusinessByLogin,
} from '../../../services/business';

import { useTranslation } from 'react-i18next';
import TikTokModal from '../../../components/TikTokModal';
import { useClient } from '../../../hooks/useClient';

function StepFinish({
  setStep,
  imagesSelectedsArrayObj,
  setImagesSelectedsArrayObj,
  imagesSelectedId,
  legendList,
  publicationTypePost,
  setPublicationTypePost,
  setFacebookPageToken,
  editSelectedId,
  // setTiktokMusic,
  // tiktokMusic,
  // setTiktokPrivacyLevel,
  // tiktokPrivacyLevel,
  // setTiktokComment,
  // tiktokComment,
  // selectedObjectItem,
}) {
  const { t } = useTranslation();
  const [oppenedModalLocale, setOppenedModalLocale] = useState(false);
  const [oppenedModalPersons, setOppenedModalPersons] = useState(false);
  const { clientData } = useClient();

  const [oppennedModalLinks, setOppennedModalLinks] = useState(false);
  const [oppennedModalHashtags, setOppennedModalHashtags] = useState(false);

  const [selectedDate, setSelectedDate] = useState(new Date().toDateString());
  const [valueHour, setValueHour] = useState('');
  const [valueMinute, setValueMinute] = useState('');
  const [tiktokCreatorInfo, setTiktokCreatorInfo] = useState(false);
  const [dropDownTiktok, setDropDownTiktok] = useState(false);
  const [tiktokPrivacyLevel, setTiktokPrivacyLevel] = useState(false);
  const [tiktokComment, setTiktokComment] = useState(false);
  const [tiktokMusic, setTiktokMusic] = useState(false);
  const [tiktokDuet, setTiktokDuet] = useState(false);
  const [tiktokStitch, setTiktokStitch] = useState(false);
  const [tiktokContentDisclosure, setTiktokContentDisclosure] = useState(false);
  const [tiktokYourBrand, setTiktokYourBrand] = useState(false);
  const [tiktokBrandedContent, setTiktokBrandedContent] = useState(false);
  // const [publicationTypePost, setPublicationTypePost] = useState(1)
  const [valueItem, setValueItem] = useState(1);

  const [tiktokBrandedInfo, setTiktokBrandedInfo] = useState(
    'Você precisa indicar se seu conteúdo promove você mesmo, um terceiro ou ambos.'
  );
  const [tiktokBrandedInfoTerms, setTiktokBrandedInfoTerms] = useState(t(''));
  const [tiktokMusicCheckbox, setTiktokMusicCheckbox] = useState(false);

  const [confirmTerms, setConfirmTerms] = useState(false);
  const [openTerms, setOpenTerms] = useState(false);

  const [facebookPages, setFacebookPages] = useState([]);

  const [selectedValues, setSelectedValues] = useState({});

  const imageUrl = imagesSelectedsArrayObj.find(
    (item) => item.id === imagesSelectedId.current
  ).image;

  const legendId = legendList[imagesSelectedId.current];
  const [showTooltipFinish, setShowTooltipFinish] = useState(false);

  useEffect(() => {
    if (confirmTerms) {
      handleFinish();
      handleLoadFacebookPages() 
    }
  }, [confirmTerms]);

  useEffect(() => {
    if (editSelectedId?.current) {
      // Recupera os tipos de redes sociais selecionadas
      const socialTypes = editSelectedId.current.socialTypes
        ?.split(',')
        .map(Number);
      const newSelectedValues = {};
      socialTypes?.forEach((type) => {
        newSelectedValues[type] = true;
      });
      setSelectedValues(newSelectedValues);

      // Recupera data e hora
      if (editSelectedId.current.selectedDate) {
        setSelectedDate(editSelectedId.current.selectedDate);
      }
      if (editSelectedId.current.valueHour) {
        setValueHour(editSelectedId.current.valueHour);
      }
      if (editSelectedId.current.valueMinute) {
        setValueMinute(editSelectedId.current.valueMinute);
      }

      // Recupera configurações do TikTok
      if (editSelectedId.current.tiktokMusic !== undefined) {
        setTiktokMusic(editSelectedId.current.tiktokMusic);
      }
      if (editSelectedId.current.tiktokPrivacyLevel) {
        setTiktokPrivacyLevel(editSelectedId.current.tiktokPrivacyLevel);
      }
      if (editSelectedId.current.tiktokComment !== undefined) {
        setTiktokComment(editSelectedId.current.tiktokComment);
      }
      if (editSelectedId.current.brandContentToggle !== undefined) {
        setTiktokBrandedContent(editSelectedId.current.brandContentToggle);
      }
      if (editSelectedId.current.brandOrganicToggle !== undefined) {
        setTiktokYourBrand(editSelectedId.current.brandOrganicToggle);
      }

      // Se tiver conteúdo de marca ou marca própria, ativa a divulgação de conteúdo
      if (
        editSelectedId.current.brandContentToggle ||
        editSelectedId.current.brandOrganicToggle
      ) {
        setTiktokContentDisclosure(true);
      }
    }
  }, [editSelectedId?.current]);

  const handleTiktokContentDisclosure = () => {
    // if (tiktokPrivacyLevel === 'SELF_ONLY') {
    //   setTiktokContentDisclosure(false)
    //   setTiktokYourBrand(false)
    //   setTiktokBrandedContent(false)
    //   notifyErrorCustom(t('stepFinish.error.contentDisclosure'))
    //   return
    // }
    if (tiktokContentDisclosure) {
      setTiktokContentDisclosure(false);
      setTiktokYourBrand(false);
      setTiktokBrandedContent(false);
      setTiktokBrandedInfo(t('stepMyPublication.tiktokBrandedInfo'));
      setTiktokBrandedInfoTerms('');
    } else {
      setTiktokContentDisclosure(true);
    }
  };

  const handleLoadFacebookPages = async () => {
    try {
      let businessId;
      if (clientData?.uuid) {
        const { data } = await getBusinessByClientId(clientData?.uuid);
        businessId = data[0]?.uuid;
      } else {
        const { data } = await getBusinessByLogin();
        businessId = data[0].uuid;
      }
      const retFacebookPages = await MetaService.getFacebookPages(businessId);

      // console.log(retFacebookPages)

      if (retFacebookPages.responseStatus !== 200) {
        return;
      }

      for (const page of retFacebookPages.data.data) {
        setFacebookPages((prevState) => [
          ...prevState,
          {
            name: page.name,
            tokenPage: page.access_token,
            id: page.id,
          },
        ]);
      }
      
    } catch (error) {
      setFacebookPages([])
      console.log(error.message)
    }
    
  };

  const handleYourBrand = () => {
    if (!tiktokYourBrand && !tiktokBrandedContent) {
      setTiktokYourBrand(true);
      setTiktokBrandedInfo(
        <>{t('stepMyPublication.tiktokBrandedInfoContentPromotional')}</>
      );
      setTiktokBrandedInfoTerms(
        <div>
          {t('stepMyPublication.tiktokBrandedInfoContentPromotionalLink')}{' '}
          <a
            target="_blank"
            href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en"
            rel="noreferrer"
          >
            {t('stepMyPublication.tiktokBrandedInfoContentPromotionalLink2')}{' '}
          </a>
        </div>
      );
    } else if (!tiktokYourBrand && tiktokBrandedContent) {
      setTiktokYourBrand(true);
      setTiktokBrandedInfo(
        <>{t('stepMyPublication.tiktokBrandedInfoPaidPartnership')}</>
      );
      setTiktokBrandedInfoTerms(
        <div>
          {t('stepMyPublication.tiktokBrandedInfoPaidPartnershipLink')}{' '}
          <a
            target="_blank"
            href="https://www.tiktok.com/legal/page/global/bc-policy/en"
            rel="noreferrer"
          >
            {t('stepMyPublication.tiktokBrandedInfoPaidPartnershipLink2')}
          </a>{' '}
          {t('stepMyPublication.tiktokBrandedInfoPaidPartnershipLink3')}{' '}
          <a
            target="_blank"
            href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en"
            rel="noreferrer"
          >
            {t('stepMyPublication.tiktokBrandedInfoContentPromotionalLink3')}
          </a>
        </div>
      );
    } else if (tiktokYourBrand && tiktokBrandedContent) {
      setTiktokYourBrand(false);
      setTiktokBrandedInfo(
        <>{t('stepMyPublication.tiktokBrandedInfoPaidPartnership')}</>
      );
      setTiktokBrandedInfoTerms(
        <>
          {t('stepMyPublication.tiktokBrandedInfoPaidPartnershipLink')}{' '}
          <a
            target="_blank"
            href="https://www.tiktok.com/legal/page/global/bc-policy/en"
            rel="noreferrer"
          >
            {t('stepMyPublication.tiktokBrandedInfoPaidPartnershipLink2')}
          </a>{' '}
          {t('stepMyPublication.tiktokBrandedInfoPaidPartnershipLink3')}{' '}
          <a
            target="_blank"
            href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en"
            rel="noreferrer"
          >
            {t('stepMyPublication.tiktokBrandedInfoContentPromotionalLink3')}
          </a>
        </>
      );
    } else {
      setTiktokYourBrand(false);
      setTiktokBrandedInfo(t('stepMyPublication.tiktokBrandedInfo'));
      setTiktokBrandedInfoTerms('');
    }
  };
  const handleYourBrandingContent = () => {
    if (!tiktokBrandedContent && !tiktokYourBrand) {
      setTiktokBrandedContent(true);
      setTiktokBrandedInfo(
        <>{t('stepMyPublication.tiktokBrandedInfoPaidPartnership')}</>
      );
      setTiktokBrandedInfoTerms(
        <>
          {t('stepMyPublication.tiktokBrandedInfoPaidPartnershipLink')}{' '}
          <a
            target="_blank"
            href="https://www.tiktok.com/legal/page/global/bc-policy/en"
            rel="noreferrer"
          >
            {t('stepMyPublication.tiktokBrandedInfoPaidPartnershipLink2')}
          </a>{' '}
          {t('stepMyPublication.tiktokBrandedInfoPaidPartnershipLink3')}{' '}
          <a
            target="_blank"
            href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en"
            rel="noreferrer"
          >
            {t('stepMyPublication.tiktokBrandedInfoContentPromotionalLink3')}
          </a>
        </>
      );
    } else if (!tiktokBrandedContent && tiktokYourBrand) {
      setTiktokBrandedContent(true);
      setTiktokBrandedInfo(
        <>{t('stepMyPublication.tiktokBrandedInfoPaidPartnership')}</>
      );
      setTiktokBrandedInfoTerms(
        <>
          {t('stepMyPublication.tiktokBrandedInfoPaidPartnershipLink')}{' '}
          <a
            target="_blank"
            href="https://www.tiktok.com/legal/page/global/bc-policy/en"
            rel="noreferrer"
          >
            {t('stepMyPublication.tiktokBrandedInfoPaidPartnershipLink2')}
          </a>{' '}
          {t('stepMyPublication.tiktokBrandedInfoPaidPartnershipLink3')}{' '}
          <a
            target="_blank"
            href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en"
            rel="noreferrer"
          >
            {t('stepMyPublication.tiktokBrandedInfoContentPromotionalLink3')}
          </a>
        </>
      );
    } else if (tiktokBrandedContent && tiktokYourBrand) {
      setTiktokBrandedContent(false);
      setTiktokBrandedInfo(
        <>{t('stepMyPublication.tiktokBrandedInfoPaidPartnership')}</>
      );
      setTiktokBrandedInfoTerms(
        <>
          {t('stepMyPublication.tiktokBrandedInfoContentPromotionalLink')}{' '}
          <a
            target="_blank"
            href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en"
            rel="noreferrer"
          >
            {' '}
            {t('stepMyPublication.tiktokBrandedInfoContentPromotionalLink2')}
          </a>
        </>
      );
    } else {
      setTiktokBrandedContent(false);
      setTiktokBrandedInfo(t('stepMyPublication.tiktokBrandedInfo'));
      setTiktokBrandedInfoTerms('');
    }
  };

  const handlePrivacyLevel = (value) => {
    // if (value === 'SELF_ONLY') {
    //   setTiktokContentDisclosure(false)
    //   setTiktokYourBrand(false)
    //   setTiktokBrandedContent(false)
    //   notifyWarningCustom(
    //     'Configorações de "Divulgação de Conteúdo" não pode ser habilitada para publicações privadas'
    //   )
    // }
    setTiktokPrivacyLevel(value);
  };

  const handleSelectedFacebookPage = (value) => {
    setFacebookPageToken(value);
  };

  const connectSocialMedia = async (networkName) => {
    let socialCount;

    if (clientData?.uuid) {
      socialCount =
        await SocialMediaConnectionService.getAllSocialMediaConnectionBusinessClientCount(
          clientData?.uuid
        );
    } else {
      socialCount =
        await SocialMediaConnectionService.getAllSocialMediaConnectionUserCount();
    }

    // const userSubscription = await SubscriptionService.getSubscriptionByUser();

    // if (userSubscription.data.length <= 0 && socialCount.data.length >= 2) {
    //   notifyWarningCustom(t("social_media.limit_message"));
    //   return;
    // } else if (userSubscription.data.length > 0) {
    //   const index = await userSubscription.data[0].Plan.PlanItems.findIndex(
    //     (item) => item.type === "integration_quantity"
    //   );
    //   const quantityItemSocial =
    //     userSubscription.data[0].Plan.PlanItems[index]?.quantity;
    //   if (socialCount.data.length >= quantityItemSocial) {
    //     notifyWarningCustom(t("social_media.limit_message"));
    //     return;
    //   }
    // }

    let businessId;

    if (clientData?.uuid) {
      const { data } = await getBusinessByClientId(clientData?.uuid);
      businessId = data[0]?.uuid;
    } else {
      const { data } = await getBusinessByLogin();
      businessId = data[0].uuid;
    }

    if (networkName === 'linkedin') {
      const { dataL } = await LinkedinService.getLinkedinByBusiness(businessId);

      const linkedinWindow = window.open(
        dataL,
        '_blank',
        'width=500,height=600'
      );

      if (linkedinWindow) {
        const checkWindow = setInterval(async () => {
          if (linkedinWindow.closed) {
            clearInterval(checkWindow);

            const checkSocialMedia =
              await SocialMediaConnectionService.getSocialMediaConnections(
                businessId
              );

            if (checkSocialMedia.data[networkName] === true) {
              setSelectedValues({ ...selectedValues, 1: true });
            }
          } else {
            if (linkedinWindow.location.href.includes('LinkedinRedirection')) {
              clearInterval(checkWindow);
              setTimeout(() => {
                linkedinWindow.close();

                setSelectedValues({ ...selectedValues, 1: true });
              }, 8000);
            }
          }
        }, 500);
      }
    }

    if (networkName === 'tiktok') {
      const dataTiktok = await TiktokService.getTiktokLoginByBusiness(
        businessId
      );

      const tiktokWindow = window.open(
        dataTiktok?.dataT,
        '_blank',
        'width=500,height=600'
      );

      if (tiktokWindow) {
        const checkWindow = setInterval(async () => {
          if (tiktokWindow.closed) {
            clearInterval(checkWindow);

            const checkSocialMedia =
              await SocialMediaConnectionService.getSocialMediaConnections(
                businessId
              );

            if (checkSocialMedia.data[networkName] === true) {
              setSelectedValues({ ...selectedValues, 3: true });
              const tiktokCreatorInfoData = await TiktokService.getTiktokCreatorInfo(
                businessId
              )
        
              if (tiktokCreatorInfoData.dataT.error.code !== 'ok') {
                notifyErrorCustom(t('stepFinish.error.tiktokCreatorInfo'))
                return
              }
        
              setTiktokCreatorInfo(tiktokCreatorInfoData.dataT.data)
        
              setDropDownTiktok(
                tiktokCreatorInfoData.dataT.data.privacy_level_options.map((item) => ({
                  label: item,
                  value: item,
                }))
              )
            }
          } else {
            if (tiktokWindow.location.href.includes('SocialMediaRedirect')) {
              clearInterval(checkWindow);
              setTimeout(async () => {
                tiktokWindow.close();

                setSelectedValues({ ...selectedValues, 3: true });
                const tiktokCreatorInfoData = await TiktokService.getTiktokCreatorInfo(
                  businessId
                )
          
                if (tiktokCreatorInfoData.dataT.error.code !== 'ok') {
                  notifyErrorCustom(t('stepFinish.error.tiktokCreatorInfo'))
                  return
                }
          
                setTiktokCreatorInfo(tiktokCreatorInfoData.dataT.data)
          
                setDropDownTiktok(
                  tiktokCreatorInfoData.dataT.data.privacy_level_options.map((item) => ({
                    label: item,
                    value: item,
                  }))
                )
              }, 8000);
            }
          }
        }, 500);
      }
    }

    if (networkName === 'twitter') {
      const dataTwitter = await TwitterService.getTwitterByBusiness(businessId);

      const twitterWindow = window.open(
        dataTwitter?.dataT,
        '_blank',
        'width=500,height=600'
      );

      if (twitterWindow) {
        const checkWindow = setInterval(async () => {
          if (twitterWindow.closed) {
            clearInterval(checkWindow);

            const checkSocialMedia =
              await SocialMediaConnectionService.getSocialMediaConnections(
                businessId
              );

            if (checkSocialMedia.data[networkName] === true) {
              setSelectedValues({ ...selectedValues, 2: true });
            }
          } else {
            if (twitterWindow.location.href.includes('SocialMediaRedirect')) {
              clearInterval(checkWindow);
              setTimeout(() => {
                twitterWindow.close();

                setSelectedValues({ ...selectedValues, 2: true });
              }, 8000);
            }
          }
        }, 500);
      }
    }

    if (networkName === 'instagram') {
      const stateValue = `instagram,MyAccountPage,${businessId}`;

      const redirectUri = window.location.origin + '/SocialMediaRedirect';

      const url = `https://www.instagram.com/oauth/authorize?client_id=481808398034661&redirect_uri=${redirectUri}&response_type=code&scope=instagram_business_basic,instagram_business_manage_messages,instagram_business_manage_comments,instagram_business_content_publish&state=${stateValue}`;

      const instagramWindow = window.open(
        url,
        '_blank',
        'width=500,height=600'
      );

      if (instagramWindow) {
        const checkWindow = setInterval(async () => {
          if (instagramWindow.closed) {
            clearInterval(checkWindow);

            const checkSocialMedia =
              await SocialMediaConnectionService.getSocialMediaConnections(
                businessId
              );

            if (checkSocialMedia.data[networkName] === true) {
              setSelectedValues({ ...selectedValues, 4: true });
            }
          } else {
            if (instagramWindow.location.href.includes('SocialMediaRedirect')) {
              clearInterval(checkWindow);
              setTimeout(() => {
                instagramWindow.close();

                setSelectedValues({ ...selectedValues, 4: true });
              }, 8000);
            }
          }
        }, 500);
      }
    }

    if (networkName === 'facebook') {
      const dataFacebook = await MetaService.getFacebookLoginByBusiness(
        businessId
      );

      const facebookWindow = window.open(
        dataFacebook?.dataT,
        '_blank',
        'width=500,height=600'
      );

      if (facebookWindow) {
        const checkWindow = setInterval(async () => {
          if (facebookWindow.closed) {
            clearInterval(checkWindow);

            const checkSocialMedia =
              await SocialMediaConnectionService.getSocialMediaConnections(
                businessId
              );

            if (checkSocialMedia.data[networkName] === true) {
              setSelectedValues({ ...selectedValues, 5: true });
            }
          } else {
            if (facebookWindow.location.href.includes('SocialMediaRedirect')) {
              clearInterval(checkWindow);
              setTimeout(() => {
                facebookWindow.close();

                setSelectedValues({ ...selectedValues, 5: true });
              }, 8000);
            }
          }
        }, 500);
      }
    }
  };

  const handleClick = async (value) => {
    const socialNetworks = {
      1: 'linkedin',
      2: 'twitter',
      3: 'tiktok',
      4: 'instagram',
      5: 'facebook',
    };

    let businessId;

    if (clientData?.uuid) {
      const { data } = await getBusinessByClientId(clientData?.uuid);
      businessId = data[0]?.uuid;
    } else {
      const { data } = await getBusinessByLogin();
      businessId = data[0].uuid;
    }

    const checkSocialMedia =
      await SocialMediaConnectionService.getSocialMediaConnections(businessId);

    const networkName = socialNetworks[value];

    if (networkName && checkSocialMedia.data[networkName] === false) {
      connectSocialMedia(networkName);
      return;
    }

    if (value === 3 && !tiktokCreatorInfo) {
      const tiktokCreatorInfoData = await TiktokService.getTiktokCreatorInfo(
        businessId
      );

      if (tiktokCreatorInfoData.dataT.error.code !== 'ok') {
        notifyErrorCustom(t('stepFinish.error.tiktokCreatorInfo'));
        return;
      }

      setTiktokCreatorInfo(tiktokCreatorInfoData.dataT.data);

      setDropDownTiktok(
        tiktokCreatorInfoData.dataT.data.privacy_level_options.map((item) => ({
          label: item,
          value: item,
        }))
      );
    }

    if (value === 5) {
      await handleLoadFacebookPages()
    }

    if (value == 3) {
      setValueItem(4);
    }

    if (value == 4) {
      setValueItem(2);
    }

    if (value <= 2) {
      setValueItem(1);
    }
    if (selectedValues[value]) {
      const newValues = { ...selectedValues };
      delete newValues[value];
      setSelectedValues(newValues);
    } else {
      setSelectedValues({ ...selectedValues, [value]: true });
    }
  };

  const [valueItim, setValueItim] = useState(1);

  // const handleSelectedIntem = (item) => {
  //   // campaignRef.current = item
  //   setValueItim(item.id)
  // }

  function formatDate2(data) {
    data = new Date(data);

    let dia = data.getDate();
    let mes = data.getMonth() + 1; // getMonth() retorna mês de 0-11
    let ano = data.getFullYear();

    dia = dia < 10 ? '0' + dia : dia;
    mes = mes < 10 ? '0' + mes : mes;

    return dia + '/' + mes + '/' + ano;
  }

  const handleSelectedIntem = (k, v) => {
    setPublicationTypePost((prevState) => ({ ...prevState, [k]: v }));
    if (v.length > 0) {
      const lastItem = v[v.length - 1];
      setValueItem(lastItem.id);
    }
  };

  const handleFinish = () => {
    // if (tiktokMusic && !tiktokMusicCheckbox) {
    //   notifyErrorCustom(t('stepMyPublication.alert_music_check'))
    //   return
    // }
    if (tiktokContentDisclosure && !tiktokYourBrand && !tiktokBrandedContent) {
      return;
    } else {
      handleSelectDate();
    }
  };

  const handleSelectDate = () => {
    let newSelectValues = Object.keys(selectedValues).toString() || '';

    if (!valueHour || !valueMinute) {
      notifyErrorCustom('Selecione um horário!');

      return;
    }

    if (!newSelectValues.length) {
      notifyErrorCustom('Selecione ao menos uma rede social!');

      return;
    }

    if (selectedValues[3] && !tiktokPrivacyLevel) {
      notifyErrorCustom(
        'Selecione a privacidade da sua publicação para o TikTok'
      );

      return;
    }

    if (tiktokContentDisclosure && !tiktokYourBrand && !tiktokBrandedContent) {
      notifyErrorCustom(
        'Ao habilitar "Divulgação de Conteúdo" do TikTok você precisa informar se seu conteudo divulga "Sua marca" ou "Conteúdo de marca"'
      );
      return;
    }

    if (
      selectedValues[4] &&
      (publicationTypePost?.instagramItems === undefined ||
        publicationTypePost?.instagramItems.length === 0)
    ) {
      notifyErrorCustom(t('stepMyPublication.instagramItemsError'));

      return;
    }

    // if (selectedValues[3]) {
    //   if (!tiktokHeadline || tiktokHeadline.trim() === '') {
    //     notifyErrorCustom(t('stepMyPublication.tiktokHeadlineRequired'))
    //     return
    //   }
    // }

    if (!confirmTerms && selectedValues[3]) {
      setOpenTerms(true);
      return;
    }

    const newImagesSelectedsArrayObj = imagesSelectedsArrayObj.map((item) => {
      if (item.id === imagesSelectedId.current) {
        return {
          ...item,
          // date: data.formatDate,
          // hour: data.valueHour + ':' + data.valueMinute,
          // valueHour: data.valueHour,
          // valueMinute: data.valueMinute,
          // selectedDate: data.selectedDate,
          // sketch: data.sketch,
          // socialTypes: data.socialTypes,

          date: formatDate2(selectedDate),
          hour: valueHour + ':' + valueMinute,
          valueHour: valueHour,
          valueMinute: valueMinute,
          selectedDate: selectedDate,
          sketch: false,
          socialTypes: newSelectValues,

          schedule: true,

          tiktokMusic: tiktokMusic,
          tiktokPrivacyLevel: tiktokPrivacyLevel,
          tiktokComment: tiktokComment,
          brandContentToggle: tiktokBrandedContent,
          brandOrganicToggle: tiktokYourBrand,
        };
      }
      return item;
    });

    setImagesSelectedsArrayObj(newImagesSelectedsArrayObj);

    setStep('stepSchedule');
  };

  const ScheduleInfoField = () => {
    const hours = [
      '01:00',
      '02:00',
      '03:00',
      '04:00',
      '05:00',
      '06:00',
      '07:00',
      '08:00',
      '09:00',
      '10:00',
      '11:00',
      '12:00',
      '13:00',
      '14:00',
      '15:00',
      '16:00',
      '17:00 ',
      '18:00',
      '19:00',
      '20:00',
      '21:00',
      '22:00',
      '23:00 ',
      '00:00',
    ];
    return (
      <div
        style={{
          flex: 1,
          flexDirection: 'column',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          height: 'calc(100vh - 176px)',
          overflow: 'auto',
        }}
      >
        <div className={styles.card}>
          <div className={styles.showPath}>
            <Picture color={'#AAAAAA'} width={20} height={20} />
            <p className={styles.patchTitle}>{t('stepFinish.publishIn')}</p>
          </div>

          <div className={styles.iconsField}>
            <div
              style={{
                width: 24,
                marginLeft: -2,
              }}
              className={styles.clickable}
              onClick={() => handleClick(5)}
            >
              <Facebook
                color={selectedValues[5] ? '#6A0098' : '#AAAAAA'}
                width={24}
                height={24}
              />
            </div>

            <div
              style={{
                width: 24,
                marginLeft: -2,
              }}
              className={styles.clickable}
              onClick={() => handleClick(1)}
            >
              <Linkedin
                color={selectedValues[1] ? '#6A0098' : '#AAAAAA'}
                width={24}
                height={24}
              />
            </div>

            <div
              style={{
                width: 24,
                marginLeft: -2,
              }}
              className={styles.clickable}
              onClick={() => handleClick(4)}
            >
              <Instagram
                color={selectedValues[4] ? '#6A0098' : '#AAAAAA'}
                width={24}
                height={24}
              />
            </div>

            <div
              style={{
                width: 24,
                marginLeft: -2,
              }}
              className={styles.clickable}
              onClick={() => handleClick(3)}
            >
              <TikTok
                color={selectedValues[3] ? '#6A0098' : '#AAAAAA'}
                width={24}
                height={24}
              />
            </div>

            <div
              style={{
                width: 24,
                marginLeft: -2,
              }}
              className={styles.clickable}
              onClick={() => handleClick(2)}
            >
              <XTwitter
                color={selectedValues[2] ? '#6A0098' : '#AAAAAA'}
                width={24}
                height={24}
              />
            </div>

            {/* <div
              style={{
                width: 24,
                marginLeft: -2,
              }}
              className={styles.clickable}
            >
              <Pinterest color={'#AAAAAA'} width={24} height={24} />
            </div> */}
          </div>
        </div>

        <div
          style={{
            marginTop: 30,
          }}
          className={styles.card}
        >
          <div className={styles.showPath}>
            <Calendar2 color={'#AAAAAA'} width={20} height={20} />
            <p className={styles.patchTitle}>{t('stepFinish.dateAndHour')}</p>
          </div>

          <div className={styles.box_calendar}>
            <div
              style={{
                flex: 1,
              }}
            >
              <SchedulerCalendar
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
              />
            </div>

            <div className={styles.container_hour_carousel}>
              <p className={styles.container_hour_carousel_title}>
                {t('stepFinish.hour')}
              </p>
              <CarouselHours
                items={hours}
                setValueMinute={setValueMinute}
                valueMinute={valueMinute}
                setValueHour={setValueHour}
                valueHour={valueHour}
              />
            </div>
          </div>
        </div>

        {tiktokCreatorInfo !== false && selectedValues[3] && imageUrl && (
          <div
            style={{
              marginTop: 30,
            }}
            className={styles.card}
          >
            <div className={styles.showPath}>
              <Subtract color={'#6A0098'} width={20} height={20} />
              <TikTok
                color={selectedValues[3] ? '#6A0098' : '#AAAAAA'}
                width={24}
                height={24}
              />
              <p className={styles.patchTitle}>
                {`Configurações do TikTok - ${tiktokCreatorInfo.creator_nickname}`}
              </p>

              <img
                style={{
                  maxWidth: '40px',
                  borderRadius: '200px',
                }}
                src={`${tiktokCreatorInfo.creator_avatar_url}`}
                //onContextMenu={(e) => e.preventDefault()}
              />
            </div>

            <div
              style={{
                marginTop: 30,
                backgroundColor: '#fff8c4',
                display: 'flex',
                alignItems: 'center',
                gap: 20,
                borderColor: '#ffd700',
              }}
              className={styles.warningCardTiktok}
            >
              <div>
                <TikTokIcon width={12} height={12} />
              </div>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                }}
              >
                <div>
                  <div className={styles.selectedModalTextTitle}>
                    {t('stepMyPublication.warning')}
                  </div>
                  <div className={styles.selectedModalTextSubtitle}>
                    {t('stepMyPublication.warning_description')}
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                marginTop: 30,

                display: 'flex',
                alignItems: 'center',
                gap: 20,
              }}
              className={styles.selectedModalCard}
            >
              <div>
                <LockClosed width={12} height={12} />
              </div>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                }}
              >
                <div className={styles.selectedModalTextTitle}>
                  {t('stepFinish.privacy_tiktok_label')}
                  <SelectSquare
                    htmlFor="select"
                    placeholder="Selecione a privacidade da sua publicação"
                    padding="10px 10px 10px 15px"
                    // value={tiktokPrivacyLevel}
                    tiktokBrandedContent={tiktokBrandedContent}
                    options={dropDownTiktok}
                    onClickItem={({ value }) => {
                      handlePrivacyLevel(value);
                    }}
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                marginTop: 18,
                backgroundColor: tiktokComment
                  ? '#f5eaf9'
                  : tiktokCreatorInfo.comment_disabled
                    ? '#edeae8'
                    : '#FBFBFB', //'#6A0098',
                display: 'flex',
                alignItems: 'center',
                gap: 20,
                pointerEvents: tiktokCreatorInfo.comment_disabled
                  ? 'none'
                  : 'auto',
                opacity: '0.5 : 1',
              }}
              className={styles.selectedModalCard}
              onClick={() =>
                tiktokComment ? setTiktokComment(false) : setTiktokComment(true)
              }
            >
              <div
                style={{
                  width: 34,
                  height: 34,
                  border: '1px solid #dcdcdc',
                  borderRadius: 200,
                  backgroundColor: tiktokComment
                    ? '#6A0098'
                    : tiktokCreatorInfo.comment_disabled
                      ? '#edeae8'
                      : '#FBFBFB', //'#6A0098',
                }}
              ></div>
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepMyPublication.comment')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepMyPublication.comment_description')}
                </div>
              </div>
            </div>
            {/* {imageUrl && (
              <div
                style={{
                  marginTop: 30,
                  backgroundColor: '#fff8c4',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 20,
                  borderColor: '#ffd700',
                }}
                className={styles.selectedModalCard}
              >
                <div>
                  <TikTokIcon width={12} height={12} />
                </div>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <div>
                    <div className={styles.selectedModalTextTitle}>
                      {t('stepMyPublication.warning')}
                    </div>
                    <div className={styles.selectedModalTextSubtitle}>
                      {t('stepMyPublication.music_confirmation_link')}
                      <a
                        target="_blank"
                        href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en"
                        rel="noreferrer"
                      >
                        {' '}
                        {t(
                          'stepMyPublication.tiktokBrandedInfoContentPromotionalLink2'
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            )} */}

            {imageUrl && (
              <div
                style={{
                  marginTop: 18,
                  backgroundColor: tiktokMusic ? '#f5eaf9' : '#FBFBFB', //'#6A0098',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 20,
                }}
                className={styles.selectedModalCard}
                onClick={() =>
                  tiktokMusic ? setTiktokMusic(false) : setTiktokMusic(true)
                }
              >
                <div
                  style={{
                    width: 34,
                    height: 34,
                    border: '1px solid #dcdcdc',
                    borderRadius: 200,
                    backgroundColor: tiktokMusic ? '#6A0098' : '#FBFBFB', //'#6A0098',
                  }}
                ></div>

                <div>
                  <div className={styles.selectedModalTextTitle}>Música</div>
                  <div className={styles.selectedModalTextSubtitle}>
                    {t('stepMyPublication.music_description')}
                    {tiktokMusic && (
                      <div className={styles.selectedModalTextSubtitle}>
                        <label
                          className={styles.checkboxLabel}
                          onClick={(e) => {
                            return;
                          }}
                        >
                          <input
                            type="checkbox"
                            className={styles.checkbox}
                            onClick={(e) => {
                              e.stopPropagation();
                              tiktokMusicCheckbox
                                ? setTiktokMusicCheckbox(false)
                                : setTiktokMusicCheckbox(true);
                            }}
                          />
                          {t('stepMyPublication.music_confirmation_link')}{' '}
                          <a
                            target="_blank"
                            href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en"
                            rel="noreferrer"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            {' '}
                            {t(
                              'stepMyPublication.tiktokBrandedInfoContentPromotionalLink2'
                            )}
                          </a>
                        </label>
                      </div>
                    )}
                  </div>
                  {/*{tiktokMusic !== false && (
                    <div className={styles.warningBox}>
                      {t('stepMyPublication.music_confirmation')}
                      <a
                        target="_blank"
                        href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en"
                        rel="noreferrer"
                      >
                        {' '}
                        {t('stepMyPublication.music_confirmation_link')}
                      </a>
                      .
                    </div>
                  )}*/}
                </div>
              </div>
            )}
            {/* {videoUrl && (
                  <div
                    style={{
                      marginTop: 18,
                      backgroundColor: tiktokDuet
                        ? '#f5eaf9'
                        : tiktokCreatorInfo.duet_disabled
                        ? '#edeae8'
                        : '#FBFBFB', //'#6A0098',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 20,
                      pointerEvents: tiktokCreatorInfo.duet_disabled
                        ? 'none'
                        : 'auto',
                      opacity: '0.5 : 1',
                    }}
                    className={styles.selectedModalCard}
                    onClick={() =>
                      tiktokDuet ? setTiktokDuet(false) : setTiktokDuet(true)
                    }
                  >
                    <div
                      style={{
                        width: 34,
                        height: 34,
                        border: '1px solid #dcdcdc',
                        borderRadius: 200,
                        backgroundColor: tiktokDuet
                          ? '#6A0098'
                          : tiktokCreatorInfo.duet_disabled
                          ? '#edeae8'
                          : '#FBFBFB', //'#6A0098',
                      }}
                    ></div>
                    <div>
                      <div className={styles.selectedModalTextTitle}>
                        {t('stepMyPublication.duet')}
                      </div>
                      <div className={styles.selectedModalTextSubtitle}>
                        {t('stepMyPublication.duet_description')}
                      </div>
                    </div>
                  </div>
                )}
                {videoUrl && (
                  <div
                    style={{
                      marginTop: 18,
                      backgroundColor: tiktokStitch
                        ? '#f5eaf9'
                        : tiktokCreatorInfo.stitch_disabled
                        ? '#edeae8'
                        : '#FBFBFB', //'#6A0098',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 20,
                      pointerEvents: tiktokCreatorInfo.stitch_disabled
                        ? 'none'
                        : 'auto',
                      opacity: '0.5 : 1',
                    }}
                    className={styles.selectedModalCard}
                    onClick={() =>
                      tiktokStitch
                        ? setTiktokStitch(false)
                        : setTiktokStitch(true)
                    }
                  >
                    <div
                      style={{
                        width: 34,
                        height: 34,
                        border: '1px solid #dcdcdc',
                        borderRadius: 200,
                        backgroundColor: tiktokStitch
                          ? '#6A0098'
                          : tiktokCreatorInfo.stitch_disabled
                          ? '#edeae8'
                          : '#FBFBFB', //'#6A0098',
                      }}
                    ></div>
                    <div>
                      <div className={styles.selectedModalTextTitle}>
                        Stitch
                      </div>
                      <div className={styles.selectedModalTextSubtitle}>
                        {t('stepMyPublication.stitch_description')}
                      </div>
                    </div>
                  </div>
                )} */}
            <div
              style={{
                marginTop: 18,
                backgroundColor: tiktokContentDisclosure
                  ? '#f5eaf9'
                  : '#FBFBFB', //'#6A0098',
                display: 'flex',
                alignItems: 'center',
                gap: 20,
                // pointerEvents: tiktokCreatorInfo.stitch_disabled
                //   ? 'none'
                //   : 'auto',
                opacity: '0.5 : 1',
              }}
              className={styles.selectedModalCard}
              onClick={
                () => handleTiktokContentDisclosure()
                // tiktokContentDisclosure
                //   ? setTiktokContentDisclosure(false)
                //   : setTiktokContentDisclosure(true),
              }
            >
              <div
                style={{
                  width: 34,
                  height: 34,
                  border: '1px solid #dcdcdc',
                  borderRadius: 200,
                  backgroundColor: tiktokContentDisclosure
                    ? '#6A0098'
                    : '#FBFBFB', //'#6A0098',
                }}
              ></div>
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepMyPublication.contentDisclosure')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepMyPublication.contentDisclosure_description')}
                </div>
              </div>
            </div>
            {tiktokContentDisclosure && (
              <div
                style={{
                  marginTop: 30,
                  backgroundColor: '#fff8c4',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 20,
                  borderColor: '#ffd700',
                }}
                className={styles.selectedModalCard}
              >
                <div>
                  <TikTokIcon width={12} height={12} />
                </div>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <div>
                    <div className={styles.selectedModalTextTitle}>
                      {t('stepMyPublication.warning')}
                    </div>
                    <div className={styles.selectedModalTextSubtitle}>
                      {tiktokBrandedInfo}
                      <br />
                      {t('stepMyPublication.tiktokBrandedInfoPosted')}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div
              style={{
                marginTop: 18,
                backgroundColor: tiktokYourBrand
                  ? '#f5eaf9'
                  : !tiktokContentDisclosure
                    ? '#edeae8'
                    : '#FBFBFB', //'#6A0098',
                display: 'flex',
                alignItems: 'center',
                gap: 20,
                pointerEvents: !tiktokContentDisclosure ? 'none' : 'auto',
                opacity: '0.5 : 1',
              }}
              className={styles.selectedModalCard}
              onClick={() => handleYourBrand()}
            >
              <div
                style={{
                  width: 34,
                  height: 34,
                  border: '1px solid #dcdcdc',
                  borderRadius: 200,
                  backgroundColor: tiktokYourBrand
                    ? '#6A0098'
                    : !tiktokContentDisclosure
                      ? '#edeae8'
                      : '#FBFBFB', //'#6A0098',
                }}
              ></div>
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepMyPublication.yourBrand')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepMyPublication.yourBrand_description')}
                </div>
              </div>
            </div>
            <div
              style={{
                marginTop: 18,
                backgroundColor: tiktokBrandedContent
                  ? '#f5eaf9'
                  : !tiktokContentDisclosure ||
                    tiktokPrivacyLevel === 'SELF_ONLY'
                    ? '#edeae8'
                    : '#FBFBFB', //'#6A0098',
                display: 'flex',
                alignItems: 'center',
                gap: 20,
                pointerEvents:
                  !tiktokContentDisclosure || tiktokPrivacyLevel === 'SELF_ONLY'
                    ? 'none'
                    : 'auto',
                opacity: '0.5 : 1',
              }}
              className={styles.selectedModalCard}
              onClick={() => handleYourBrandingContent()}
            >
              <div
                style={{
                  width: 34,
                  height: 34,
                  border: '1px solid #dcdcdc',
                  borderRadius: 200,
                  backgroundColor: tiktokBrandedContent
                    ? '#6A0098'
                    : !tiktokContentDisclosure ||
                      tiktokPrivacyLevel === 'SELF_ONLY'
                      ? '#edeae8'
                      : '#FBFBFB', //'#6A0098',
                }}
              ></div>
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepMyPublication.brandedContent')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepMyPublication.brandedContent_description')}
                </div>
              </div>
            </div>
            <div className={styles.selectedModalTextSubtitle}>
              {tiktokBrandedInfoTerms}
            </div>
          </div>
        )}
        {selectedValues[2] && imageUrl && (
          <div
            style={{
              marginTop: 30,
            }}
            className={styles.card}
          >
            <div className={styles.showPath}>
              <Subtract color={'#6A0098'} width={20} height={20} />
              <XTwitter color={'#6A0098'} width={24} height={24} />
              <p className={styles.patchTitle}>{'Configurações do X'}</p>
            </div>

            <div
              style={{
                marginTop: 30,
                backgroundColor: '#fff8c4',
                display: 'flex',
                alignItems: 'center',
                gap: 20,
                borderColor: '#ffd700',
              }}
              className={styles.warningCardTiktok}
            >
              <div>
                <XTwitter color={'#6A0098'} width={24} height={24} />
              </div>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                }}
              >
                <div>
                  <div className={styles.selectedModalTextTitle}>
                    {'Aviso sobre o limite de caracteres:'}
                  </div>
                  <div className={styles.selectedModalTextSubtitle}>
                    {
                      '* Postagens de contas padrão no X estão limitadas a 280 caracteres.'
                    }
                  </div>
                  <div className={styles.selectedModalTextSubtitle}>
                    {
                      '* Para contas com assinatura do X Blue, o limite é de até 10.000 caracteres.'
                    }
                  </div>
                  <div className={styles.selectedModalTextSubtitle}>
                    {
                      'Certifique-se de que sua postagem está dentro do limite permitido antes de enviá-la.'
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {selectedValues[1] && imageUrl && (
          <div
            style={{
              marginTop: 30,
            }}
            className={styles.card}
          >
            <div className={styles.showPath}>
              <Subtract color={'#6A0098'} width={20} height={20} />
              <Linkedin color={'#6A0098'} width={24} height={24} />
              <p className={styles.patchTitle}>{'Configurações do Linkedin'}</p>
            </div>

            <div
              style={{
                marginTop: 30,

                display: 'flex',
                alignItems: 'center',
                gap: 20,
              }}
              className={styles.selectedModalCard}
            >
              <div>
                <LockClosed width={12} height={12} />
              </div>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                }}
              >
                <div className={styles.selectedModalTextSubtitle}>
                  <SelectSquare
                    htmlFor="select"
                    placeholder={t('stepMyPublication.selectPrivacyLevel')}
                    padding="10px 10px 10px 15px"
                    // value={tiktokPrivacyLevel}
                    // tiktokContentDisclosure={tiktokContentDisclosure}
                    options={[
                      {
                        id: 1,
                        label: 'Público',
                        value: 'PUBLIC',
                      },
                      {
                        id: 2,
                        label: 'Conexões',
                        value: 'CONNECTIONS',
                      },
                    ]}
                    onClickItem={({ value }) => {
                      handlePrivacyLevel(value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {selectedValues[4] && imageUrl && (
          <div
            style={{
              marginTop: 30,
            }}
            className={styles.card}
          >
            <div className={styles.showPath}>
              <Subtract color={'#6A0098'} width={20} height={20} />
              <Instagram color={'#6A0098'} width={24} height={24} />
              <p className={styles.patchTitle}>
                {'Configurações do Instagram'}
              </p>
            </div>
            {imageUrl && (
              <div
                style={{
                  marginTop: 30,

                  display: 'flex',
                  alignItems: 'center',
                  gap: 20,
                }}
                className={styles.selectedModalCard}
              >
                <div>
                  <Picture color={'#6A0098'} width={20} height={20} />
                </div>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <div className={styles.selectedModalTextSubtitle}>
                    {'Selecione o tipo de publicação'}
                    <MultiplySelectSquare
                      backgroundColor={'#EDEDED'}
                      border={true}
                      borderColor={'#dadada'}
                      placeholder={'Selecione'}
                      arrowDirection="down"
                      variante="gray"
                      defaultSelected={() => {
                        if (publicationTypePost.instagramItems?.length > 0) {
                          return publicationTypePost.instagramItems;
                        }
                        return [];
                      }}
                      options={[
                        {
                          id: 2,
                          label: 'Feed',
                          value: 'FEED',
                        },
                        {
                          id: 3,
                          label: 'Stories',
                          value: 'STORIES',
                        },
                      ]}
                      fontSize={12}
                      // onClickItem={handleSelectedIntem}
                      onClickItem={(value) => {
                        handleSelectedIntem('instagramItems', value);
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            {/* {videoUrl && (
                <div
                  style={{
                    marginTop: 30,

                    display: 'flex',
                    alignItems: 'center',
                    gap: 20,
                  }}
                  className={styles.selectedModalCard}
                >
                  <div>
                    <Picture color={'#6A0098'} width={20} height={20} />
                  </div>
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                    }}
                  >
                    <div className={styles.selectedModalTextSubtitle}>
                      <MultiplySelectSquare
                        htmlFor="select"
                        // backgroundColor={'#EDEDED'}
                        // border={true}
                        // borderColor={'#dadada'}
                        placeholder={'Selecione o tipo de publicação'}
                        arrowDirection="down"
                        variante="gray"
                        options={
                          selectedValues[1]
                            ? [
                                {
                                  id: 1,
                                  label: 'Feed',
                                  value: 'FEED',
                                },
                              ]
                            : [
                                {
                                  id: 1,
                                  label: 'Feed',
                                  value: 'FEED',
                                },
                                {
                                  id: 2,
                                  label: 'Stories',
                                  value: 'STORIES',
                                },
                              ]
                        }
                        fontSize={12}
                        onClickItem={(value) => {
                          handlePublicationModeMovie('instagramItems', value)
                        }}
                        // onClickItem={handlePublicationModeMovie}
                        defaultSelected={[
                          {
                            id: 1,
                            label: 'Feed',
                            value: 'FEED',
                          },
                          {
                            id: 2,
                            label: 'Stories',
                            value: 'STORIES',
                          },
                        ].find((item) => item?.id === publicationMovieType)}
                      />
                    </div>
                  </div>
                </div>
              )} */}

            {/* <div
              onClick={() => setOppenedModalPersons(true)}
              style={{
                marginTop: 18,

                display: 'flex',
                alignItems: 'center',
                gap: 20,
              }}
              className={styles.selectedModalCard}
            >
              <MorePersonsIcon color={'#610f92'} size={'24'} />
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepMyPublication.markPeople')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepMyPublication.markPeople_description')}
                </div>
              </div>
            </div> */}

            {/* <div
              onClick={() => setOppennedModalHashtags(true)}
              style={{
                marginTop: 18,

                display: 'flex',
                alignItems: 'center',
                gap: 20,
              }}
              className={styles.selectedModalCard}
            >
              <HashtagIcon color={'#610f92'} size={'22'} />
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepMyPublication.addHashtags')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepMyPublication.addHashtags_description')}
                </div>
              </div>
            </div> */}
          </div>
        )}

        {selectedValues[5] && imageUrl && (
          <div
            style={{
              marginTop: 30,
            }}
            className={styles.card}
          >
            <div className={styles.showPath}>
              <Subtract color={'#6A0098'} width={20} height={20} />
              <Facebook color={'#6A0098'} width={24} height={24} />
              <p className={styles.patchTitle}>{t('facebook_settings')}</p>
            </div>

            <div
              style={{
                marginTop: 30,

                display: 'flex',
                alignItems: 'center',
                gap: 20,
              }}
              className={styles.selectedModalCard}
            >
              <div>
                <User color={'#6A0098'} width={20} height={20} />
              </div>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                }}
              >
                <div className={styles.selectedModalTextTitle}>
                  <p style={{ margin: 0 }}>
                    {t('stepMyPublication.select_page')}
                  </p>
                  <SelectSquare
                    backgroundColor={'#EDEDED'}
                    border={true}
                    borderColor={'#dadada'}
                    placeholder={'Selecione a página'}
                    arrowDirection="down"
                    options={facebookPages.map((page) => {
                      return {
                        label: page.name,
                        value: page.tokenPage,
                        id: page.id,
                      };
                    })}
                    fontSize={12}
                    onClickItem={(value) => {
                      handleSelectedFacebookPage(value);
                    }}
                  />
                </div>
              </div>
            </div>

            {imageUrl && (
              <div
                style={{
                  marginTop: 30,

                  display: 'flex',
                  alignItems: 'center',
                  gap: 20,
                }}
                className={styles.selectedModalCard}
              >
                <div>
                  <Picture color={'#6A0098'} width={20} height={20} />
                </div>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <div className={styles.selectedModalTextTitle}>
                    <p style={{ margin: 0 }}>
                      {t('stepMyPublication.publication_type')}
                    </p>
                    <MultiplySelectSquare
                      backgroundColor={'#EDEDED'}
                      border={true}
                      borderColor={'#dadada'}
                      placeholder={'Selecione o tipo de publicação'}
                      arrowDirection="down"
                      variante="gray"
                      options={[
                        {
                          id: 2,
                          label: 'Feed',
                          value: 'REELS',
                        },
                        {
                          id: 3,
                          label: 'Stories',
                          value: 'STORIES',
                        },
                      ]}
                      fontSize={12}
                      // onClickItem={handleSelectedIntem}
                      onClickItem={(value) => {
                        handleSelectedIntem('facebookItems', value);
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            {/* {videoUrl && (
              <div
                style={{
                  marginTop: 30,

                  display: 'flex',
                  alignItems: 'center',
                  gap: 20,
                }}
                className={styles.selectedModalCard}
              >
                <div>
                  <Picture color={'#6A0098'} width={20} height={20} />
                </div>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <div className={styles.selectedModalTextTitle}>
                    <p style={{ margin: 0 }}>{t('stepMyPublication.publication_type')}</p>
                    <MultiplySelectSquare
                      htmlFor="select"
                      // backgroundColor={'#EDEDED'}
                      // border={true}
                      // borderColor={'#dadada'}
                      placeholder={'Selecione o tipo de publicação'}
                      arrowDirection="down"
                      variante="gray"
                      options={[
                        {
                          id: 1,
                          label: 'Reels',
                          value: 'REELS',
                        },
                        {
                          id: 2,
                          label: 'Stories',
                          value: 'STORIES',
                        },
                      ]}
                      fontSize={12}
                      onClickItem={(value) => {
                        handlePublicationModeMovie('facebookItems', value)
                      }}
                      // onClickItem={handlePublicationModeMovie}
                      defaultSelected={[
                        {
                          id: 1,
                          label: 'Reels',
                          value: 'REELS',
                        },
                        {
                          id: 2,
                          label: 'Stories',
                          value: 'STORIES',
                        },
                      ].find((item) => item?.id === publicationMovieType)}
                    />
                  </div>
                </div>
              </div>
            )} */}

            {/* title facebook */}
            {/* <div
                style={{
                  marginTop: 30,

                  display: 'flex',
                  alignItems: 'center',
                  gap: 20,
                }}
                className={styles.selectedModalCard}
              >
                <div>
                  <PencilSquare color={'#6A0098'} width={12} height={12} />
                </div>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <div className={styles.selectedModalTextTitle}>
                    <p style={{ margin: 0 }}>{t('stepMyPublication.title')}</p>
                    <input
                      value={tiktokHeadline}
                      onChange={(e) => setTiktokHeadline(e.target.value)}
                      type="text"
                      placeholder={t('stepMyPublication.placeholder_title')}
                      style={{
                        width: '100%',
                        height: 40,
                        borderRadius: 5,
                        border: '1px solid #ededed',
                        backgroundColor: '#ededed',
                        padding: '0 10px',
                        marginTop: 3,
                        marginBottom: 3,

                        color: '#190027',
                      }}
                    />
                  </div>
                </div>
              </div> */}

            {/* <div
              onClick={() => setOppenedModalLocale(true)}
              style={{
                marginTop: 18,

                display: 'flex',
                alignItems: 'center',
                gap: 20,
              }}
              className={styles.selectedModalCard}
            >
              <PinMapsIcon color={'#610f92'} size={'24'} />
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepMyPublication.location')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepMyPublication.location_description')}
                </div>
              </div>
            </div> */}

            {/* <div
              onClick={() => setOppenedModalPersons(true)}
              style={{
                marginTop: 18,

                display: 'flex',
                alignItems: 'center',
                gap: 20,
              }}
              className={styles.selectedModalCard}
            >
              <MorePersonsIcon color={'#610f92'} size={'24'} />
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepMyPublication.markPeople')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepMyPublication.markPeople_description')}
                </div>
              </div>
            </div> */}

            <div
              style={{
                marginTop: 18,

                display: 'flex',
                alignItems: 'center',
                gap: 20,
              }}
              className={styles.selectedModalCard}
            >
              <FacebookChatIcon color={'#610f92'} size={'24'} />

              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepMyPublication.receiveMessages')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepMyPublication.receiveMessages_description')}
                </div>
              </div>
            </div>

            <div
              onClick={() => setOppennedModalLinks(true)}
              style={{
                marginTop: 18,

                display: 'flex',
                alignItems: 'center',
                gap: 20,
              }}
              className={styles.selectedModalCard}
            >
              <LinksIcon color={'#610f92'} size={'22'} />
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepMyPublication.addLinks')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepMyPublication.addLinks_description')}
                </div>
              </div>
            </div>

            {/* <div
              onClick={() => setOppennedModalHashtags(true)}
              style={{
                marginTop: 18,

                display: 'flex',
                alignItems: 'center',
                gap: 20,
              }}
              className={styles.selectedModalCard}
            >
              <HashtagIcon color={'#610f92'} size={'22'} />
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepMyPublication.addHashtags')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepMyPublication.addHashtags_description')}
                </div>
              </div>
            </div> */}
          </div>
        )}

        {/* {tiktokCreatorInfo !== false && selectedValues[3] && (
          <div
            style={{
              marginTop: 30,
            }}
            className={styles.card}
          >
            <div className={styles.showPath}>
              <Subtract color={'#AAAAAA'} width={20} height={20} />
              <p
                className={styles.patchTitle}
              >{`Configurações do TikTok - ${tiktokCreatorInfo.creator_nickname}`}</p>
              <img
                style={{
                  maxWidth: '40px',
                  borderRadius: '200px',
                }}
                src={`${tiktokCreatorInfo.creator_avatar_url}`}
              />
            </div>

            <div
              style={{
                marginTop: 30,
                backgroundColor: '#fff8c4',
                display: 'flex',
                alignItems: 'center',
                gap: 20,
                borderColor: '#ffd700',
              }}
              className={styles.warningCardTiktok}
            >
              <div>
                <TikTokIcon width={12} height={12} />
              </div>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                }}
              >
                <div>
                  <div className={styles.selectedModalTextTitle}>
                    {t('stepFinish.warning')}
                  </div>
                  <div className={styles.selectedModalTextSubtitle}>
                    {t('stepFinish.warningDescription')}
                    
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                marginTop: 30,

                display: 'flex',
                alignItems: 'center',
                gap: 20,
              }}
              className={styles.selectedModalCard}
            >
              <div>
                <LockClosed width={12} height={12} />
              </div>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                }}
              >
                <div className={styles.selectedModalTextSubtitle}>
                  <SelectSquare
                    htmlFor="select"
                    placeholder="Selecione a privacidade da sua publicação"
                    tiktokContentDisclosure={tiktokContentDisclosure}
                    padding="10px 10px 10px 15px"
                    value={dropDownTiktok?.value}
                    options={dropDownTiktok}
                    onClickItem={({ value }) => {
                      handlePrivacyLevel(value)
                    }}
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                marginTop: 18,
                backgroundColor: tiktokComment
                  ? '#f5eaf9'
                  : tiktokCreatorInfo.comment_disabled
                  ? '#edeae8'
                  : '#FBFBFB', //'#6A0098',
                display: 'flex',
                alignItems: 'center',
                gap: 20,
                pointerEvents: tiktokCreatorInfo.comment_disabled
                  ? 'none'
                  : 'auto',
                opacity: '0.5 : 1',
              }}
              className={styles.selectedModalCard}
              onClick={() =>
                tiktokComment ? setTiktokComment(false) : setTiktokComment(true)
              }
            >
              <div
                style={{
                  width: 34,
                  height: 34,
                  border: '1px solid #dcdcdc',
                  borderRadius: 200,
                  backgroundColor: tiktokComment
                    ? '#6A0098'
                    : tiktokCreatorInfo.comment_disabled
                    ? '#edeae8'
                    : '#FBFBFB', //'#6A0098',
                }}
              ></div>
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepFinish.comment')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepFinish.commentDescription')}
                </div>
              </div>
            </div>
            {imageUrl && (
              <div
                style={{
                  marginTop: 30,
                  backgroundColor: '#fff8c4',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 20,
                  borderColor: '#ffd700',
                }}
                className={styles.selectedModalCard}
              >
                <div>
                  <TikTokIcon width={12} height={12} />
                </div>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <div>
                    <div className={styles.selectedModalTextTitle}>Aviso</div>
                    <div className={styles.selectedModalTextSubtitle}>
                      {t('stepFinish.musicConfirmationLink')}
                      <a
                        target="_blank"
                        href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en"
                        rel="noreferrer"
                      >
                        {' '}
                        {t('stepFinish.musicConfirmation')}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            )}
           
            <div
              style={{
                marginTop: 18,
                backgroundColor: tiktokMusic ? '#f5eaf9' : '#FBFBFB', //'#6A0098',
                display: 'flex',
                alignItems: 'center',
                gap: 20,
              }}
              className={styles.selectedModalCard}
              onClick={() =>
                tiktokMusic ? setTiktokMusic(false) : setTiktokMusic(true)
              }
            >
              <div
                style={{
                  width: 34,
                  height: 34,
                  border: '1px solid #dcdcdc',
                  borderRadius: 200,
                  backgroundColor: tiktokMusic ? '#6A0098' : '#FBFBFB', //'#6A0098',
                }}
              ></div>
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepFinish.music')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepFinish.musicDescription')}
                </div>
              </div>
            </div>

            <div
              style={{
                marginTop: 18,
                backgroundColor: tiktokContentDisclosure
                  ? '#f5eaf9'
                  : '#FBFBFB', 
                display: 'flex',
                alignItems: 'center',
                gap: 20,
                opacity: '0.5 : 1',
              }}
              className={styles.selectedModalCard}
              onClick={
                () => handleTiktokContentDisclosure()
              }
            >
              <div
                style={{
                  width: 34,
                  height: 34,
                  border: '1px solid #dcdcdc',
                  borderRadius: 200,
                  backgroundColor: tiktokContentDisclosure
                    ? '#6A0098'
                    : '#FBFBFB', 
                }}
              ></div>
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepFinish.contentDisclosure')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepFinish.contentDisclosureDescription')}
                </div>
              </div>
            </div>

            {tiktokContentDisclosure && (
              <div
                style={{
                  marginTop: 30,
                  backgroundColor: '#fff8c4',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 20,
                  borderColor: '#ffd700',
                }}
                className={styles.selectedModalCard}
              >
                <div>
                  <TikTokIcon width={12} height={12} />
                </div>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <div>
                    <div className={styles.selectedModalTextTitle}>
                      {t('stepFinish.warning')}
                    </div>
                    <div className={styles.selectedModalTextSubtitle}>
                      {tiktokBrandedInfo}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div
              style={{
                marginTop: 18,
                backgroundColor: tiktokYourBrand
                  ? '#f5eaf9'
                  : !tiktokContentDisclosure
                  ? '#edeae8'
                  : '#FBFBFB', //'#6A0098',
                display: 'flex',
                alignItems: 'center',
                gap: 20,
                pointerEvents: !tiktokContentDisclosure ? 'none' : 'auto',
                opacity: '0.5 : 1',
              }}
              className={styles.selectedModalCard}
              onClick={() => handleYourBrand()}
            >
              <div
                style={{
                  width: 34,
                  height: 34,
                  border: '1px solid #dcdcdc',
                  borderRadius: 200,
                  backgroundColor: tiktokYourBrand
                    ? '#6A0098'
                    : !tiktokContentDisclosure
                    ? '#edeae8'
                    : '#FBFBFB', //'#6A0098',
                }}
              ></div>
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepFinish.yourBrand')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepFinish.yourBrandDescription')}
                </div>
              </div>
            </div>

            <div
              style={{
                marginTop: 18,
                backgroundColor: tiktokBrandedContent
                  ? '#f5eaf9'
                  : !tiktokContentDisclosure
                  ? '#edeae8'
                  : '#FBFBFB', //'#6A0098',
                display: 'flex',
                alignItems: 'center',
                gap: 20,
                pointerEvents: !tiktokContentDisclosure ? 'none' : 'auto',
                opacity: '0.5 : 1',
              }}
              className={styles.selectedModalCard}
              onClick={() => handleYourBrandingContent()}
            >
              <div
                style={{
                  width: 34,
                  height: 34,
                  border: '1px solid #dcdcdc',
                  borderRadius: 200,
                  backgroundColor: tiktokBrandedContent
                    ? '#6A0098'
                    : !tiktokContentDisclosure
                    ? '#edeae8'
                    : '#FBFBFB', //'#6A0098',
                }}
              ></div>
              <div>
                <div className={styles.selectedModalTextTitle}>
                  {t('stepFinish.brandedContent')}
                </div>
                <div className={styles.selectedModalTextSubtitle}>
                  {t('stepFinish.brandedContentDescription')}
                </div>
              </div>
            </div>
          </div>
        )} */}

        <div
          style={{
            marginTop: 30,
          }}
          className={styles.card}
        >
          <div className={styles.showPath}>
            <Subtract color={'#AAAAAA'} width={20} height={20} />
            <p className={styles.patchTitle}>{'Configurações Adicionais'}</p>
          </div>
          <div
            onClick={() => setOppenedModalLocale(true)}
            style={{
              marginTop: 30,

              display: 'flex',
              alignItems: 'center',
              gap: 20,
            }}
            className={styles.selectedModalCard}
          >
            <PinMapsIcon color={'#610f92'} size={'24'} />
            <div>
              <div className={styles.selectedModalTextTitle}>
                {t('stepFinish.location')}
              </div>
              <div className={styles.selectedModalTextSubtitle}>
                {t('stepFinish.locationDescription')}
              </div>
            </div>
          </div>

          <div
            onClick={() => setOppenedModalPersons(true)}
            style={{
              marginTop: 18,

              display: 'flex',
              alignItems: 'center',
              gap: 20,
            }}
            className={styles.selectedModalCard}
          >
            <MorePersonsIcon color={'#610f92'} size={'24'} />
            <div>
              <div className={styles.selectedModalTextTitle}>
                {t('stepFinish.markPeople')}
              </div>
              <div className={styles.selectedModalTextSubtitle}>
                {t('stepFinish.markPeopleDescription')}
              </div>
            </div>
          </div>

          <div
            style={{
              marginTop: 18,

              display: 'flex',
              alignItems: 'center',
              gap: 20,
            }}
            className={styles.selectedModalCard}
          >
            <FacebookChatIcon color={'#610f92'} size={'24'} />

            <div>
              <div className={styles.selectedModalTextTitle}>
                {t('stepFinish.receiveMessages')}
              </div>
              <div className={styles.selectedModalTextSubtitle}>
                {t('stepFinish.receiveMessagesDescription')}
              </div>
            </div>
          </div>

          <div
            onClick={() => setOppennedModalLinks(true)}
            style={{
              marginTop: 18,

              display: 'flex',
              alignItems: 'center',
              gap: 20,
            }}
            className={styles.selectedModalCard}
          >
            <LinksIcon color={'#610f92'} size={'22'} />
            <div>
              <div className={styles.selectedModalTextTitle}>
                {t('stepFinish.addLinks')}
              </div>
              <div className={styles.selectedModalTextSubtitle}>
                {t('stepFinish.addLinksDescription')}
              </div>
            </div>
          </div>

          <div
            onClick={() => setOppennedModalHashtags(true)}
            style={{
              marginTop: 18,

              display: 'flex',
              alignItems: 'center',
              gap: 20,
            }}
            className={styles.selectedModalCard}
          >
            <HashtagIcon color={'#610f92'} size={'22'} />
            <div>
              <div className={styles.selectedModalTextTitle}>
                {t('stepFinish.addHashtags')}
              </div>
              <div className={styles.selectedModalTextSubtitle}>
                {t('stepFinish.addHashtagsDescription')}
              </div>
            </div>
          </div>
        </div>

        {/* <div
          style={{
            marginTop: 30,
          }}
          className={styles.card}
        >
          <div className={styles.showPath}>
            <Subtract color={'#AAAAAA'} width={20} height={20} />
            <p className={styles.patchTitle}>
              {t('stepFinish.privacySettings')}
            </p>
          </div>

          <div
            style={{
              marginTop: 30,

              display: 'flex',
              alignItems: 'center',
              gap: 20,
            }}
            className={styles.selectedModalCard}
          >
            <div
              style={{
                width: 34,
                height: 34,
                border: '1px solid #dcdcdc',
                borderRadius: 200,
              }}
            ></div>
            <div>
              <div className={styles.selectedModalTextTitle}>
                {t('stepFinish.public')}
              </div>
              <div className={styles.selectedModalTextSubtitle}>
                {t('stepFinish.publicDescription')}
              </div>
            </div>
          </div>

          <div
            style={{
              marginTop: 18,

              display: 'flex',
              alignItems: 'center',
              gap: 20,
            }}
            className={styles.selectedModalCard}
          >
            <div
              style={{
                width: 34,
                height: 34,
                border: '1px solid #dcdcdc',
                borderRadius: 200,
              }}
            ></div>
            <div>
              <div className={styles.selectedModalTextTitle}>
                {t('stepFinish.restricted')}
              </div>
              <div className={styles.selectedModalTextSubtitle}>
                {t('stepFinish.restrictedDescription')}
              </div>
            </div>
          </div>
        </div> */}
      </div>
    );
  };

  const SchedulePhotosField = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',

          width: 480,
          marginLeft: 20,
          gap: 20,

          height: 'calc(100vh - 176px)',
          overflow: 'auto',
        }}
      >
        <div
          style={{
            backgroundColor: '#fbfbfb',
            flex: 1,
          }}
        >
          <div className={styles.container_select_preview}>
            {/* <SelectSquare
              backgroundColor={'#EDEDED'}
              border={true}
              borderColor={'#dadada'}
              placeholder={t('stepFinish.selectPreview')}
              arrowDirection="down"
              options={[
                {
                  id: 1,
                  label: t('stepFinish.previewFeedFacebook'),
                },
                {
                  id: 2,
                  label: t('stepFinish.previewFeedInstagram'),
                },
                {
                  id: 3,
                  label: t('stepFinish.previewFeedFacebookStories'),
                },
                {
                  id: 4,
                  label: t('stepFinish.previewFeedInstagramStories'),
                },
              ]}
              fontSize={12}
              //  defaultSelected={locationsStatesOptions.find(
              //    (e) => e.value === locationsStatesOptions?.value
              //  )}
              onClickItem={handleSelectedIntem}
            /> */}
          </div>
          {/* <ImageRender image={imageUrl} type={valueItim} legend={legendId} /> */}
          <ImageRender
            image={imageUrl}
            type={valueItem}
            legend={legendId}
            setValueItem={setValueItem}
            selectedValues={selectedValues}
          />
        </div>
        <div>{/* <CarrouselComponent /> */}</div>
      </div>
    );
  };

  const ButtonsBottomField = () => {
    return (
      <div
        style={{
          height: 70,
        }}
      >
        <TikTokModal
          isOpen={openTerms}
          setOpenTerms={setOpenTerms}
          setConfirmTerms={setConfirmTerms}
          handleFinish={handleFinish}
        />
        <div className={styles.button_nav}>
          <button
            className={styles.button_back}
            onClick={() => {
              setStep('stepSchedule');
            }}
          >
            <p className={styles.button_title}>{t('stepFinish.backButton')}</p>
          </button>

          <div
            style={{
              display: 'flex',
              gap: '10px',
            }}
          >
            <button
              className={
                tiktokContentDisclosure &&
                !tiktokYourBrand &&
                !tiktokBrandedContent
                  ? styles.button_next_disabled
                  : styles.button_next
              }
              onClick={handleFinish}
              onMouseEnter={() => setShowTooltipFinish(true)} // Mostrar o tooltip ao passar o mouse
              onMouseLeave={() => setShowTooltipFinish(false)} // Ocultar o tooltip quando sair
            >
              <p className={styles.button_title}>
                {t('stepFinish.finishButton')}
              </p>
            </button>
            {showTooltipFinish &&
              tiktokContentDisclosure &&
              !tiktokYourBrand &&
              !tiktokBrandedContent && (
              <div className={styles.tooltip}>
                {t('stepMyPublication.finish_tooltip')}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={styles.container_page}>
        <div
          style={{
            display: 'flex',
            flex: 1,
          }}
        >
          {ScheduleInfoField()}
          {SchedulePhotosField()}
        </div>

        <ButtonsBottomField />

        <ModalComponent
          isOpen={oppenedModalLocale}
          onClose={() => setOppenedModalLocale(false)}
          style={{
            width: 600,
            height: 240,
          }}
        >
          <div className={styles.modal_content}>
            <div className={styles.header_close}>
              <div className={styles.modal_title}>
                {t('stepFinish.location')}
              </div>
              <div
                className={styles.close_modal}
                onClick={() => {
                  setOppenedModalLocale(false);
                }}
              >
                <Cross width={12} height={12} />
              </div>
            </div>

            <input
              type="text"
              placeholder="Digite aqui..."
              style={{
                width: '100%',
                height: 40,
                borderRadius: 5,
                border: '1px solid #ededed',
                backgroundColor: '#ededed',
                padding: '0 10px',
                marginTop: 20,
                marginBottom: 20,

                color: '#190027',
              }}
            />

            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
              }}
            >
              <button
                className={styles.button_next}
                style={{
                  height: 40,
                  width: 180,
                }}
                onClick={() => {
                  setOppenedModalLocale(false);
                }}
              >
                <p
                  className={styles.button_title}
                  style={{
                    fontSize: 12,
                  }}
                >
                  Finalizar
                </p>
              </button>
            </div>
          </div>
        </ModalComponent>

        <ModalComponent
          isOpen={oppenedModalPersons}
          onClose={() => setOppenedModalPersons(false)}
          style={{
            width: 600,
            height: 280,
          }}
        >
          <div className={styles.modal_content}>
            <div className={styles.header_close}>
              <div className={styles.modal_title}>
                {t('stepFinish.markPeople')}
              </div>
              <div
                className={styles.close_modal}
                onClick={() => {
                  setOppenedModalPersons(false);
                }}
              >
                <Cross width={12} height={12} />
              </div>
            </div>

            <div className={styles.iconsField} style={{ marginTop: 20 }}>
              <div
                style={{
                  width: 24,
                  marginLeft: -2,
                }}
                className={styles.clickable}
              >
                <Facebook color={'#AAAAAA'} width={24} height={24} />
              </div>

              <div
                style={{
                  width: 24,
                  marginLeft: -2,
                }}
                className={styles.clickable}
              >
                <Linkedin color={'#AAAAAA'} width={24} height={24} />
              </div>

              <div
                style={{
                  width: 24,
                  marginLeft: -2,
                }}
                className={styles.clickable}
              >
                <Instagram color={'#AAAAAA'} width={24} height={24} />
              </div>

              <div
                style={{
                  width: 24,
                  marginLeft: -2,
                }}
                className={styles.clickable}
              >
                <TikTok color={'#AAAAAA'} width={24} height={24} />
              </div>

              <div
                style={{
                  width: 24,
                  marginLeft: -2,
                }}
                className={styles.clickable}
              >
                <XTwitter color={'#AAAAAA'} width={24} height={24} />
              </div>
            </div>

            <input
              type="text"
              placeholder={t('stepFinish.markPeoplePlaceholder')}
              style={{
                width: '100%',
                height: 40,
                borderRadius: 5,
                border: '1px solid #ededed',
                backgroundColor: '#ededed',
                padding: '0 10px',
                marginTop: 20,
                marginBottom: 20,

                color: '#190027',
              }}
            />

            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
              }}
            >
              <button
                className={styles.button_next}
                style={{
                  height: 40,
                  width: 180,
                }}
                onClick={() => {
                  setOppenedModalPersons(false);
                }}
              >
                <p
                  className={styles.button_title}
                  style={{
                    fontSize: 12,
                  }}
                >
                  {t('stepFinish.finishButton')}
                </p>
              </button>
            </div>
          </div>
        </ModalComponent>

        <ModalComponent
          isOpen={oppennedModalLinks}
          onClose={() => setOppennedModalLinks(false)}
          style={{
            width: 600,
            height: 240,
          }}
        >
          <div className={styles.modal_content}>
            <div className={styles.header_close}>
              <div className={styles.modal_title}>
                {t('stepFinish.addLink')}
              </div>
              <div
                className={styles.close_modal}
                onClick={() => {
                  setOppennedModalLinks(false);
                }}
              >
                <Cross width={12} height={12} />
              </div>
            </div>

            <input
              type="text"
              placeholder={t('stepFinish.addLinkPlaceholder')}
              style={{
                width: '100%',
                height: 40,
                borderRadius: 5,
                border: '1px solid #ededed',
                backgroundColor: '#ededed',
                padding: '0 10px',
                marginTop: 20,
                marginBottom: 20,

                color: '#190027',
              }}
            />

            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
              }}
            >
              <button
                className={styles.button_next}
                style={{
                  height: 40,
                  width: 180,
                }}
                onClick={() => {
                  setOppennedModalLinks(false);
                }}
              >
                <p
                  className={styles.button_title}
                  style={{
                    fontSize: 12,
                  }}
                >
                  Finalizar
                </p>
              </button>
            </div>
          </div>
        </ModalComponent>

        <ModalComponent
          isOpen={oppennedModalHashtags}
          onClose={() => setOppennedModalHashtags(false)}
          style={{
            width: 600,
            height: 240,
          }}
        >
          <div className={styles.modal_content}>
            <div className={styles.header_close}>
              <div className={styles.modal_title}>
                {t('stepFinish.addHashtags')}
              </div>
              <div
                className={styles.close_modal}
                onClick={() => {
                  setOppennedModalHashtags(false);
                }}
              >
                <Cross width={12} height={12} />
              </div>
            </div>

            <input
              type="text"
              placeholder={t('stepFinish.addHashtagsPlaceholder')}
              style={{
                width: '100%',
                height: 40,
                borderRadius: 5,
                border: '1px solid #ededed',
                backgroundColor: '#ededed',
                padding: '0 10px',
                marginTop: 20,
                marginBottom: 20,

                color: '#190027',
              }}
            />

            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
              }}
            >
              <button
                className={styles.button_next}
                style={{
                  height: 40,
                  width: 180,
                }}
                onClick={() => {
                  setOppennedModalHashtags(false);
                }}
              >
                <p
                  className={styles.button_title}
                  style={{
                    fontSize: 12,
                  }}
                >
                  {t('stepFinish.finishButton')}
                </p>
              </button>
            </div>
          </div>
        </ModalComponent>
      </div>
    </>
  );
}

export default StepFinish;
